var _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    viewBox: "0 0 114 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3256 78.806C11.3256 62.4754 25.1628 48.266 42.2923 47.1184L112.728 42.3999L96.3689 81.7155C94.104 87.1589 89.5518 92.1177 83.9957 95.718C78.4406 99.3177 71.9241 101.532 65.768 101.532H28.4899C18.9883 101.532 11.3256 94.1816 11.3256 85.1654V78.806Z",
    fill: "#FCC24C",
    stroke: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7552 64.2015C52.7552 55.952 59.7727 49.2253 68.4615 49.2253H103.746L97.2124 65.0985C95.6239 68.9576 92.4105 72.482 88.4716 75.0441C84.5336 77.6055 79.9121 79.1776 75.5447 79.1776H68.4625C59.7656 79.1776 52.7552 72.4529 52.7552 64.2015Z",
    fill: "#ED9111",
    stroke: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5371 25.1514H57.1591V53.384H27.5371V25.1514Z",
    fill: "#FCC24C",
    stroke: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1592 24.6514C57.1592 37.6493 46.1146 48.2253 32.441 48.2253C18.7675 48.2253 7.7229 37.6493 7.7229 24.6514C7.7229 11.6534 18.7675 1.07739 32.441 1.07739C46.1146 1.07739 57.1592 11.6534 57.1592 24.6514Z",
    fill: "#FCC24C",
    stroke: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9475 21.2122C40.9475 23.7635 38.7741 25.8709 36.0437 25.8709C33.3132 25.8709 31.1398 23.7635 31.1398 21.2122C31.1398 18.6609 33.3132 16.5535 36.0437 16.5535C38.7741 16.5535 40.9475 18.6609 40.9475 21.2122Z",
    fill: "#5B68C0",
    stroke: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5306 18.6329C17.5306 20.7094 15.7605 22.4318 13.5274 22.4318C11.2943 22.4318 9.52417 20.7094 9.52417 18.6329C9.52417 16.5564 11.2943 14.834 13.5274 14.834C15.7605 14.834 17.5306 16.5564 17.5306 18.6329Z",
    fill: "#5B68C0",
    stroke: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.32596 38.4949C1.05606 38.2234 0.857671 37.984 0.719446 37.7997L15.982 28.4347C16.0006 28.4412 16.0204 28.4481 16.0412 28.4555C16.2233 28.5193 16.4887 28.6139 16.8203 28.7359C17.4837 28.9802 18.4111 29.3344 19.4657 29.7738C21.5814 30.6552 24.1835 31.8688 26.1952 33.2145C27.2027 33.8885 28.0364 34.5788 28.5877 35.2574C29.1425 35.9403 29.3609 36.5465 29.282 37.0801C29.2039 37.608 28.8114 38.2186 27.7867 38.8593C26.7637 39.499 25.1761 40.125 22.8577 40.6978C13.5667 42.9933 7.94374 42.0981 4.67184 40.6894C3.03435 39.9844 1.9728 39.1456 1.32596 38.4949Z",
    fill: "#ED9111",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuck);
export default __webpack_public_path__ + "static/media/duck.f9fb8c7b06196f84231c1f0b5a45a5ff.svg";
export { ForwardRef as ReactComponent };